<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>

<section>
    <div class="main-div">
        <div class="images-div">
            <div class="mobile-div">
                <img
                    src="images/Perfomance/Vectarytexture3.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="back-div">
                <img
                    src="images/Perfomance/back3.svg"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="Number">
                <p>3</p>
            </div>
            <div class="text-div">
                <p>Performers & Opus</p>
                <p>Voice Over Artists</p>
                <p>
                    No play is complete without dialogs. No character is
                    complete without a voice.
                </p>
                <p>
                    Our game changer technology enables you to turn your voice
                    into an everlasting intellectual property.
                </p>
                <p>
                    Whenever a director or producer wants to include it in their
                    end production, you get paid without having to step into a
                    studio and to memorize a single line.
                </p>
                <p>
                    We’re inviting you to become part of making history, vote on
                    important societal issues arising for it and of course, get
                    rewarded for your time.
                </p>
                <div class="btn-div">
                    <DesktopButton2
                        state = "Performer"
                        width="24.074vh"
                        text1 = "Join Artist Governance Council"
                        text2="(Voice Over Seat)"
                        AnimationColor="black"
                        TextColorAfter="#67eebb"
                        BorderColorAfter="black"
                        text3="15"
                    />
                </div>
            </div>
        </div>
        <div class="scroll_div">
            
            <p class="scrollText" >scroll / drag</p>
            <svg
            width="6.185vh"
            height="0.741vh"
            viewBox="0 0 72 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="img"
        >
            <path
                d="M71.3536 4.35355C71.5488 4.15829 71.5488 3.84171 71.3536 3.64645L68.1716 0.464466C67.9763 0.269204 67.6597 0.269204 67.4645 0.464466C67.2692 0.659728 67.2692 0.976311 67.4645 1.17157L70.2929 4L67.4645 6.82843C67.2692 7.02369 67.2692 7.34027 67.4645 7.53553C67.6597 7.7308 67.9763 7.7308 68.1716 7.53553L71.3536 4.35355ZM0 4.5H71V3.5H0V4.5Z"
            />
        </svg>
        </div>
    </div>
</section>

<style>
    .main-div {
        width: 161.944vh;
        height: 100vh;
        position: relative;
    }
    .images-div {
        display: flex;
        position: relative;
    }
    .back-div {
        position: absolute;
        right: 0vh;
        width: 111.944vh;
        height: 100vh;
        pointer-events:none ;
        z-index: -1;
    }
    .mobile-div {
        left: -40vh;
        position: absolute;
        width: 168.611vh;
        height: 100vh;
        pointer-events:none ;
    }
    .Number{
        position: absolute;
        top: -6.229vw;
        right: 9.7vh;
    }
    .Number p{
        margin: 0;
        font-weight: 700;
        font-size: 27.778vh;
        line-height: 27.778vh;
        color: rgba(255, 255, 255, 0.6);
        font-family: 'Orbitron';
    }
    .text-div {
        position: absolute;
        right: 14.63vh;
        width: 64.537vh;
        font-family: "Orbitron";
        top: 16.222vh;
    }
    .text-div p:nth-child(1) {
        font-size: 1.296vh;
        letter-spacing: 0.058vh;
        font-weight: 400;
        margin-left: 3vh;
        text-transform: uppercase;
    }
    .text-div p:nth-child(2) {
        font-size: 5.556vh;
        line-height: 5.556vh;
        margin-top: 2.407vh;
        margin-bottom: 6.667vh;
        letter-spacing: 0.058vh;
        font-weight: 700;
        text-transform: uppercase;
        width: 43.889vh;
        margin-left: 3vh;
    }
    .text-div p:nth-child(3) {
        margin-top: 2.315vh;
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        font-weight: 400;
    }
    .text-div p:nth-child(4) {
        margin-top: 2.315vh;
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        font-weight: 700;
    }
    .text-div p:nth-child(5) {
        margin-top: 2.315vh;
        font-size: 1.852vh;
        line-height: 2.593vh;
        font-weight: 400;
        letter-spacing: 0.058vh;
    }
    .text-div p:nth-child(6) {
        margin-top: 2.315vh;
        font-size: 1.852vh;
        line-height: 2.593vh;
        font-weight: 400;
        letter-spacing: 0.058vh;
    }
    .btn-div {
        margin-top: 4.537vh;
    }
    .scroll_div {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 2.5vh;
        left: -11vh;
    }
    .scroll_div .scrollText {
        font-size: 1.481vh;
        font-weight: 500;
        line-height: 1.857vh;
        font-family: "Orbitron";
        color: black;
        text-transform: capitalize;
    }
    .scroll_div .img {
        margin-left: 1.778vh;
        width: 6.185vh;
        height: 0.741vh;
        fill: black;
}
</style>
